/** Welk pop-uptype je bewerkt (tab Tekst) — gekoppeld aan preview rechts. */
export const COPY_EDIT_SECTIONS = [
  { id: 'welcome', label: 'Nieuwe bezoeker', previewVariant: 'welcome', hasThanks: true },
  { id: 'returning', label: 'Terugkerend', previewVariant: 'returning_offer', hasThanks: true },
  { id: 'form', label: 'Formulier (naam)', previewVariant: 'welcome', hasThanks: false },
  { id: 'consent', label: 'AVG consent', previewVariant: 'welcome', hasThanks: false },
];

/** Oude losse tabs → type + phase. */
const LEGACY_SECTION_MAP = {
  success: { id: 'welcome', phase: 'success' },
  returning_thanks: { id: 'returning', phase: 'success' },
  returning_newsletter: { id: 'returning', phase: 'form' },
};

export function resolveCopyEditSection(sectionId) {
  const legacy = LEGACY_SECTION_MAP[sectionId];
  if (legacy) {
    const row = COPY_EDIT_SECTIONS.find((s) => s.id === legacy.id);
    return { section: row || COPY_EDIT_SECTIONS[0], phase: legacy.phase };
  }
  const row = COPY_EDIT_SECTIONS.find((s) => s.id === sectionId);
  return { section: row || COPY_EDIT_SECTIONS[0], phase: null };
}

export const RETURNING_COPY_SUGGESTIONS = {
  returning_offer_kicker: '',
  returning_offer_sub: 'Eén klik — korting direct in je winkelmand',
  returning_known_label: 'Korting voor',
  title_returning_offer: 'Leuk dat je terug bent',
  body_returning_offer:
    'Als vaste klant krijg je extra voordeel. Bevestig hieronder — we zetten je korting meteen klaar.',
  button_returning_offer: 'Activeer mijn korting',
  success_title_returning: 'Leuk dat je terug bent!',
  success_body_applied_returning:
    'We hebben als vaste klant € 10,00 korting in je winkelmand gezet. Geniet van het shoppen.',
  success_body_returning:
    'Klik op Kopieer code en plak hem bij “Waardebon toepassen” in je winkelmandje.',
};
